import * as types from '../types/user';
import {Map} from 'immutable';
import {updateState} from '../helpers/index';

export default function User(state = Map({
  isAuth: false,
  profile: Map(),
  authModalOpened: false,
}), action) {
  switch (action.type) {
    case types.USER_LOGIN:
    case types.USER_UPDATED:
    case types.USER_GET_PROFILE:
      return updateState(state, {
        profile: action.data,
      });
    case types.USER_REMOVED:
      return updateState(state, {
        profile: {},
      });
    case types.USER_REGISTER:
    case types.USER_REQUEST:
    case types.RESET_PASSWORD:
    case types.FORGOT_PASSWORD:
      return updateState(state);
    case types.USER_LOGOUT:
      return updateState(state, {
        profile: {},
      });
    case types.AUTH_OPEN_MODAL:
      return updateState(state, {
        authModalOpened: true,
      });
    case types.AUTH_CLOSE_MODAL:
      return updateState(state, {
        authModalOpened: false,
      });
    case types.SIGN_IN:
      return updateState(state, {
        isAuth: true,
      });
    case types.SIGN_OUT:
      return updateState(state, {
        isAuth: false,
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/user.js